<div class="user-profile-groups-list">
  <p>
    This user belongs to
    {{ courtSystemUser.groups.length }} group{{ courtSystemUser.groups.length > 1 ? 's' : '' }}:
  </p>
  <section class="card-list card--borderless">
    <div class="card-list__header card--borderless">
      <div class="card-list__header-item">Name</div>
      <div class="card-list__header-item">Actions</div>
    </div>
    @for (group of courtSystemUser.groups; track group) {
      <div class="card card--borderless">
        <ul class="card__section">
          <li class="card__item">
            <span class="card__item-heading">User Group</span>
            <span class="card__item-data">{{ group.name }}</span>
          </li>
          <li class="card__item">
            <button
              ftrButton
              [color]="buttonColor.Secondary"
              [size]="buttonSize.Small"
              (click)="removeMember(group.id, courtSystemUser.id, group.name)"
            >
              Remove user from this group
            </button>
          </li>
        </ul>
      </div>
    }
  </section>
</div>
